import React, { useEffect } from 'react';
import { ScoreEvaluationPage01 } from './layout_01/ScoreEvaluationLayout';
import { ScoreEvaluationPage02 } from './layout_02/ScoreEvaluationLayout';
import { useAppSelector } from '../../store/hook';
import { getTemplateLayout } from '../../common/utils/fallbackCondition';
import { useTranslation } from 'react-i18next';

const ScoreEvaluationPageLayoutMap: { [key: string]: React.FC } = {
  TEMPLATE_LAYOUT_01: ScoreEvaluationPage01,
  TEMPLATE_LAYOUT_02: ScoreEvaluationPage02,
  TEMPLATE_LAYOUT_04: ScoreEvaluationPage02,
};

export const ScoreEvaluationPage = (): React.JSX.Element => {
  const template = useAppSelector((state) => state.template);
  const { t } = useTranslation();
  const { layoutCode } = template;
  const layout = getTemplateLayout(layoutCode);
  const ScoreEvaluationPage = ScoreEvaluationPageLayoutMap[layout];
  const customPageName = `${t('evaluatingTitle')} | `;
  const pageTitle = `${customPageName}${t('shlExperiences')}`;

  useEffect(() => {
    document.title = pageTitle;
  });

  return <ScoreEvaluationPage />;
};
